import { render, staticRenderFns } from "./Eronet.vue?vue&type=template&id=60c70831&"
import script from "./Eronet.vue?vue&type=script&lang=js&"
export * from "./Eronet.vue?vue&type=script&lang=js&"
import style0 from "./Eronet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports